<form id="custom-field-form" #customFieldForm="ngForm" class="bl-font-color--base not-inherit-validation-error">
  <ecp-content-spinner [spinnerSmall]="true" *ngIf="(applicationCustomFields?.length ?? 0) == 0"></ecp-content-spinner>
  <div class="bl-margin-bottom--16">
    <fieldset>
      <div *ngFor="let field of applicationCustomFields; index as Index" class="bl-check-wrap bl-margin-bottom--8 bl-margin-top--4">
        <div *ngIf="hasTextField(field.specificControlType) && field.fieldLabel && field.isShownOnEntry">
          <div class="bl-margin-top--16 bl-margin-bottom--24">
            <div class="bl-margin-bottom--16">
              <label
                class="bl-label bl-font-weight--800 bl-font-size--14"
                [class.bl-required]="field.isRequired"
                for="oao-custom-field-input-{{ field.propertyPathID }}"
              >
                {{ field.fieldLabel }}
              </label>
              <input
                type="text"
                class="bl-input"
                id="oao-custom-field-input-{{ field.propertyPathID }}"
                name="oao-custom-field-input-{{ field.propertyPathID }}"
                [attr.placeholder]="getPlaceholderText(field.specificControlType)"
                [percent]="field.specificControlType === percentageprecision"
                [attr.maxLength]="getMaxLength(field)"
                [(ngModel)]="field.fieldValue"
                #fieldValue="ngModel"
                [class.bl-error]="(isSubmitClicked || !fieldValue.pristine) && !fieldValue.valid"
                (blur)="focused = false; processMask($event, field, Index, false)"
                (focus)="focused = true; processMask($event, field, Index)"
                (cut)="processMask($event, field, Index)"
                (paste)="processMask($event, field, Index)"
                (input)="processMask($event, field, Index)"
                (keyup)="processMask($event, field, Index)"
                (mouseup)="processMask($event, field, Index)"
                [required]="field.isRequired"
                [attr.data-automation-id]="'custom-field-' + Index"
              />
              <div class="bl-error-msg bl-margin-right--16" *ngIf="(isSubmitClicked || !fieldValue.pristine) && !fieldValue.valid">
                <div *ngIf="fieldValue.errors?.required">
                  <span>This is a required field</span>
                  <span aria-label="alert" aria-live="assertive" class="bl-screen-reader-only">
                    {{ field.fieldLabel }} is a required field
                  </span>
                </div>
                <div *ngIf="fieldValue.errors?.percent">
                  <span>This field requires a percentage between 0% and 100%</span>
                  <span aria-label="alert" aria-live="assertive" class="bl-screen-reader-only">
                    {{ field.fieldLabel }} requires a percentage between 0% and 100%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!hasTextField(field.specificControlType) && field.fieldLabel && field.isShownOnEntry">
          <div class="bl-margin-top--16 bl-margin-bottom--24">
            <div class="bl-margin-bottom--16">
              <div class="bl-check-wrap bl-margin-bottom--8">
                <input
                  type="checkbox"
                  name="oao-transfer-accepted"
                  id="oao-custom-field-chkbx-{{ field.propertyPathID }}"
                  [attr.data-automation-id]="'custom-field-' + Index"
                  name="oao-custom-field-chkbx-{{ field.propertyPathID }}"
                  class="bl-display--inline-block"
                  [(ngModel)]="field.fieldValue"
                  #fieldValue="ngModel"
                  [required]="field.isRequired"
                  #checkBoxValue="ngModel"
                  (change)="updateBundleData(field.fieldValue, Index, field.fieldLabel)"
                />
                <label for="oao-custom-field-chkbx-{{ field.propertyPathID }}" class="bl-label bl-font-size--16 bl-font-color--black">
                  {{ field.fieldLabel }}
                </label>
                <div class="bl-error-msg bl-margin-right--16" *ngIf="(isSubmitClicked || !fieldValue.pristine) && !fieldValue.valid">
                  <div *ngIf="fieldValue.errors?.required">
                    <span>This is a required field</span>
                    <span aria-label="alert" aria-live="assertive" class="bl-screen-reader-only">
                      {{ field.fieldLabel }} is a required field
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
  <div *ngIf="questions_not_found">
    <p class="bl-label bl-font-size--14">
      {{ questions_not_found }}
    </p>
  </div>
</form>
